export const validateEmail = (value: string) => {
  const emailRegExp =
    // eslint-disable-next-line security/detect-unsafe-regex
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  return emailRegExp.test(value);
};

export const validateOrderNumber = (value: string) => /^.{9,10}$/.test(value);

export const getErrorMessageIdByErrorCode = (code?: string): string => {
  switch (code) {
    case 'E05':
    case 'E07':
    case 'E08':
    case 'E09':
      return 'link.server_error_combination';
    case 'E10':
      return 'link.server_error_cannot_pay';
    case 'E12':
      return 'link.server_error_cancelled';
    case 'E13':
      return 'link.server_error_paid';
    default:
      return 'generic_error_message';
  }
};
